<template>
  <div>
    <div class="row justify-content-end">
      <div class="col-auto">
        <button @click="refresh()" class="btn border">
          <i class="bi bi-check2-square fs-5"></i> Actualiser
        </button>
      </div>

      <div class="col-auto">
        <button
          @click="
            $router.push({
              name: 'checks-suppliers-edit',
              params: {
                reference: check.reference,
              },
            })
          "
          class="btn border"
        >
          <i class="bi bi-pencil-square fs-5"></i> Modifier
        </button>
      </div>
      <div class="col-auto">
        <button @click="print(check.reference)" class="btn border">
          <i class="bi bi-printer fs-5"></i> Imprimer
        </button>
      </div>

      <div class="col-auto">
        <button @click="printReceipt(check.reference)" class="btn border">
          <i class="bi bi-printer fs-5"></i> Imprimer Bon Réception
        </button>
      </div>

      <div class="col-auto">
        <button @click="refresh()" class="btn border">
          <i class="bi bi-arrow-clockwise fs-5"></i> Actualiser
        </button>
      </div>

      <div class="col-auto" v-if="check.status != 'Payé'">
        <button
          @click="refresh()"
          class="btn border border-success text-success"
        >
          <i class="bi bi-arrow-clockwise fs-5"></i> Payé
        </button>
      </div>

      <div class="col-auto" v-if="check.status != 'Impayé'">
        <button @click="refresh()" class="btn border border-danger text-danger">
          <i class="bi bi-arrow-clockwise fs-5"></i> Impayé
        </button>
      </div>
    </div>
    <br />
    <div class="row align-items-stretch">
      <div class="col-4">
        <div class="row justify-content-between">
          <div class="col">Fournisseur :</div>
          <div class="col fw-bold">
            <span v-if="check.supplier">
              {{ check.supplier.society }}
            </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col">Nº Telephone :</div>
          <div class="col fw-bold">
            <span v-if="check.supplier">
              {{ check.supplier.phone }}
            </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col">Societie</div>
          <div class="col fw-bold">
            <span v-if="check.supplier">
              {{ check.supplier.society }}
            </span>
          </div>
        </div>
      </div>

      <!--  -->
      <div class="col-4 justify-content-between border-start border-danger">
        <div class="row">
          <div class="col">État</div>
          <div class="col fw-bold">
            {{ check.status }}
          </div>
        </div>

        <div class="row">
          <div class="col">Remarque</div>
          <div class="col fw-bold">
            {{ check.remark }}
          </div>
        </div>
      </div>

      <!--  -->
      <div class="col-4 justify-content-between border-start border-danger">
        <div class="row">
          <div class="col">Montant Total</div>
          <div class="col fw-bold">{{ check.amount }} DH</div>
        </div>

        <div class="row">
          <div class="col">Montant en lettre :</div>
          <div class="col fw-bold text-uppercase">
            {{ check.writtenAmount }} DH
          </div>
        </div>

        <div class="row">
          <div class="col">Nº Cheque</div>
          <div class="col fw-bold">
            {{ check.checkNumber }}
          </div>
        </div>

        <div class="row">
          <div class="col">Date</div>
          <div class="col fw-bold">
            {{ check.date }}
          </div>
        </div>

        <div class="row">
          <div class="col">Échéance</div>
          <div class="col fw-bold">0</div>
        </div>
      </div>
    </div>
    <br />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },

  mounted() {
    this.$store.dispatch("check/show", this.$route.params.reference);
  },
  computed: {
    ...mapGetters("check", {
      check: "getCheck",
    }),
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("check/show", this.$route.params.reference);
    },

    async print(reference) {
      await this.$store.dispatch("check/print", reference);
    },
    async printReceipt(reference) {
      await this.$store.dispatch("check/printReceiptVoucher", reference);
    },
  },
};
</script>
